<div class="report-card">
  <div class="header">
    Work To Be Completed
  </div>
  <div class="bad-text"></div>

  <div>
    <canvas id="piechart" class="piechart"></canvas>

    <app-loading-swirly [isLoading]="loading"></app-loading-swirly>

    <div class="pretend-table-row">
      <span>
        Type
      </span>
      <span>
        Total
      </span>
    </div>
    <div class="horizontal-line"></div>
    @if (!loading) {
      <div class="table">
        @for (record of workToBeCompleted; track record) {
          <div>
            <div class="pretend-table-row">
              <span class="no-background">{{ record.type }}</span>
              <span class="no-background">{{ record.total | currency: 'USD' }}</span>
            </div>
            <div class="horizontal-line"></div>
          </div>
        }
      </div>
    }
  </div>
</div>